// Top secret file for april 1st 2023 drops ;)
// Drop on Mar 31 for time zone folks
const deadline = new Date('March 31 2023');

function isAprilFools() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  return new Date(`March 31 ${year}`) <= currentDate && currentDate <= new Date(`April 2 ${year}`);
}

// not really a real react hook, and is used in some non-function-component contexts so be careful
export function useIsPastReleaseDate() {
  return new Date() >= deadline;
}

// If not past initial release date, no sounds
// Otherwise, if is April Fool's, 100% probability
// Otherwise, in the future, 1% probability
// Also useIsPastReleaseDate is not a real hook, so is safe here
// eslint-disable-next-line react-hooks/rules-of-hooks
export const soundProbability = useIsPastReleaseDate() ? (isAprilFools() ? 1 : 0.01) : 0;
